import React from 'react';
import ReactDOM from 'react-dom';

import JsonService from 'components/year-review/services/JsonService';
import YRGraph from 'components/year-review/components/YRGraph';

import 'components/year-review/components/legend/index';
import 'components/year-review/services/SvgSprite';

class YearReview {
    init = async (lang, year) => {
        const { data } = await import(`components/year-review/assets/json/${year}/data.json`);
        const { config } = await import(`components/year-review/assets/json/${year}/config.json`);

        if (config && data) {
            const dataWithValues = JsonService.refactorPropertiesToValues(data);
            const graphsData = JsonService.mergeJsons(config[lang].config, dataWithValues);

            graphsData.forEach(graphData => {
                const graphDiv = document.querySelector(`[data-graph-id="${graphData.id}"]`);

                if (graphDiv) {
                    ReactDOM.render(
                        <YRGraph data={graphData} />,
                        graphDiv,
                    );
                }
            });
        }
    };
}

export default YearReview;
